module.exports = __webpack_public_path__ + "d928840ad52d598a9a18f1b8d4c50d6e.pdf";